module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isBreakpointGroup) { ;
__p += '\n    <div class="group-thumb-container';
 if (allowedToPublish) { ;
__p += ' draggable';
 } ;
__p += '" draggable="' +
__e( allowedToPublish ) +
'">\n        <div class="variant-thumbs-wrapper">\n            ';
 _.each(thumbs, function (thumb) { ;
__p += '\n                <div class="variant-outline" style="width:' +
__e( thumb.width ) +
'px; height:' +
__e( thumb.height ) +
'px; left:' +
__e( thumb.x ) +
'px;"></div>\n            ';
 }); ;
__p += '\n            <div class="experience-thumbnail-wrapper"></div>\n        </div>\n    </div>\n	<ul class="group-variants">\n        ';
 _.each(thumbs, function (thumb, index) { ;
__p += '\n            <li class="variant-icon">#' +
__e( index + 1 ) +
'</li>\n        ';
 }); ;
__p += '\n    </ul>\n';
 } else { ;
__p += '\n    <div class="experience-thumbnail-wrapper';
 if (allowedToPublish) { ;
__p += ' draggable';
 } ;
__p += '" draggable="' +
__e( allowedToPublish ) +
'" data-toggle="tooltip"></div>\n    ';
 if (isLocalized) { ;
__p += '\n    	<div class="localized flag small ' +
__e( localeString ) +
'"></div>\n    ';
 } ;
__p += '\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/DraggableContentThumbnailView.tpl
// module id = 3138
// module chunks = 0